<script setup>
import { getGpsData,makeResizedImageURL,postImage,getRevGeoData } from '@/composable/useCommon'
import { prefList,prefTranslater } from '@/composable/usePoint'
import axios from 'axios'
import dayjs from 'dayjs'
import { nextTick } from 'vue'
// const citycodeData = require('@/assets/onebox_citycode.json')
import citycodeData from '@/assets/onebox_citycode.json'
import { useAsyncData } from 'nuxt/app'

const { gtag } = useGtag()

const config = useRuntimeConfig()
const apiDomain = config.public.apiHost
const siteDomain = config.public.siteHost
const postFailed = ref(false)
const invalidFileDetected = ref(false)
const router = useRouter()
const isButtonDisabled = ref(false)
const button = ref({
  text: '送信する',
  link: '',
  isActive: false
})
const imageUploaded = ref(false)
const uploadImageUrl = ref('')
const pointLat = ref('')
const pointLon = ref('')
const cityName = ref('')
const cityCode = ref('')
const prefRoma = ref('')
const prefJp = ref('')
const pointName = ref('')
const isLoadingNow = ref(false)
const allowedImageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']
onMounted(async () => {
  if(!navigator.userAgent.includes('weathernews') && !/android/i.test(navigator.userAgent)) {
    location.href = '/sakura/'
  }
  try {
    const { latitude, longitude } = await getGpsData()
    pointLat.value = latitude
    pointLon.value = longitude
    const revGeoData = await getRevGeoData(siteDomain, pointLat.value, pointLon.value)
    cityName.value = revGeoData[`${pointLat.value}/${pointLon.value}`]['city']['name']
    cityCode.value = revGeoData[`${pointLat.value}/${pointLon.value}`]['city']['code']
    prefJp.value = revGeoData[`${pointLat.value}/${pointLon.value}`]['city']['pref']
    prefRoma.value = prefTranslater[prefJp.value]
    pointName.value = `${prefJp.value}${cityName.value}`
  } catch (error) {
    pointLat.value = ''
    pointLon.value = ''
    cityName.value = ''
    cityCode.value = ''
    prefJp.value = ''
    prefRoma.value = ''
    pointName.value = ''
  }
  const runtimeConfig = useRuntimeConfig()
  gtag('config', runtimeConfig.public.gtag.id, getGtagConfig())
})

const selectedPref = ref('')
const selectedCitycode = ref('')
//const { data: cityList } = await useFetch('/api/city_get')
//const cityList = citycodeData
const cityList = {}
for (const key in citycodeData) {
  if (citycodeData.hasOwnProperty(key)) {
    const item = citycodeData[key]
    const newName = item.name.replace(prefTranslater[item.pref] + "県", "").replace(prefTranslater[item.pref], "")
    cityList[key] = {
      ...item,
      name: newName,
      citycode: key
    };
  }
}
const cityListOfSelectedPref = ref([])
watch(selectedPref, (nowSelectedPref, lastSelectedPref) => {
  if(nowSelectedPref){
    cityListOfSelectedPref.value = []
    Object.keys(cityList).forEach(citycode => {
      cityList[citycode]['pref'] === nowSelectedPref ? cityListOfSelectedPref.value.push(cityList[citycode]) : null
    })
  } else {
    selectedCitycode.value = ''
    cityName.value = ''
    pointName.value = ''
    button.value.isActive = false
  }
})

watch(selectedCitycode, (nowSelectedCitycode, lastSelectedCitycode) => {
  if(nowSelectedCitycode){
    cityCode.value = nowSelectedCitycode
    cityName.value = cityList[nowSelectedCitycode]['name']
    pointLat.value = cityList[nowSelectedCitycode]['latd']
    pointLon.value = cityList[nowSelectedCitycode]['lond']
    prefRoma.value = selectedPref.value
    prefJp.value = prefTranslater[selectedPref.value]
    pointName.value = `${prefJp.value}${cityName.value}`
    if(imageUploaded.value) {
      button.value.isActive = true
    }
  } else {
    selectedCitycode.value = ''
    cityName.value = ''
    pointName.value = ''
    button.value.isActive = false
  }
})

const file = ref(null)
const imgData = ref(null)
const uploadedImage = async(e) => {
  file.value = e.target.files[0]
  if (!file.value || !allowedImageTypes.includes(file.value.type)) {
    invalidFileDetected.value = true
    return
  }
  imageUploaded.value = true
  imgData.value = await resizeImage() 
  if(pointName.value) {
    button.value.isActive = true
  }
}

const resizeImage = async () => {
  const resizedImage = await makeResizedImageURL(file.value)
  return resizedImage
}

const goToResultPage = async() => {
  const formData = new FormData()
  isLoadingNow.value = true
  const akey = wniutil.get_akey_v2()
  if(akey) {
    sessionStorage.setItem('akey', akey)
  }
  formData.append('image', imgData.value)
  formData.append('lat', pointLat.value)
  formData.append('lon', pointLon.value)
  formData.append('cityname', cityName.value)
  formData.append('citycode', cityCode.value)
  formData.append('pref_roma', prefRoma.value)
  formData.append('akey', akey)
  formData.append('is_dummy', '0')
  sessionStorage.setItem('akey', akey)
  try {
    if(!imgData.value || !cityName.value) {
      postFailed.value = true
      throw new Error(`Post Error`)
    }
    const response = await postImage(siteDomain, formData)
    isLoadingNow.value = false
    if(response.status == 'OK') {
      postFailed.value = false
      const kaikaDate = response.date
      const mankaiDate = response.mankai_date
      const postDate = `${dayjs().format('YYYY/MM/DD')}`
      const predictionStatus = response.prediction
      const imageId = response.image_id
      
      const queryParams = new URLSearchParams()
      queryParams.append('cityname', cityName.value)
      queryParams.append('kaikaDate', kaikaDate)
      queryParams.append('mankaiDate', mankaiDate)
      queryParams.append('predictionStatus', predictionStatus)
      queryParams.append('imageId', imageId)
      queryParams.append('postDate', postDate)
      button.value.link = {
        path: '/forecast/result/',
        query: queryParams.toString()
      }
    } else {
      postFailed.value = true
    }
  } catch (error) {
    console.error('Error posting image:', error)
    postFailed.value = true
  } finally {
    isLoadingNow.value = false
    if(button.value.link) {
      await nextTick()
      if (typeof button.value.link.query === 'string') {
        await router.push(`${button.value.link.path}?${button.value.link.query}`)
      } else {
        await router.push(button.value.link)
      }
    }
  }
}

const handleCloseModal = (eType) => {
  if(eType == 'postFailed') postFailed.value = false
  else if(eType == 'invalidFileDetected') invalidFileDetected.value = false
}


useHead({
  title: '桜AI開花予想 | ウェザーニュース',
  meta: [
  { name: 'description', content: "" },
    { property: 'og:image', content: "https://gvs.weathernews.jp/s/sakura/img/2025/sakura_sns_hd_ai.jpg" },
  ],
})
</script>

<template>
  <div>
    <div v-if="!isLoadingNow" class="registration">
      <p class="title">開花予想日を知りたい<br>つぼみの写真を送信してください。</p>
      <div class="box">
        <!-- 画像読み込み前 -->
        <label v-if="!imageUploaded" class="upload" for="upload">
          <span class="upload__text">タップして<br>写真を選択or撮影</span>
        </label>
        <!-- 画像読み込み後 -->
        <div v-if="imageUploaded" class="image">
          <div class="image__block">
            <img id="thumbnail" />
            <!-- <canvas id="canvas" :src="uploadImageUrl" width="200" height="112" alt=""/> -->
          </div>
          <label class="link" for="upload">
            <span class="link__text">写真を変更する</span>
          </label>
        </div>
        <input type="file" id="upload" name="file" @change="uploadedImage" enctype="multipart/form-data"/>
        <div class="address">
          <p class="address__heading">つぼみの撮影場所は？</p>
          <p class="address__title"><span class="address__point">{{ pointName }}</span> 付近</p>
          <p class="address__text">現在地以外でつぼみを撮影した場合は、以下から選択してください</p>
          <div class="address__select">
            <select name="pref" id="pref" v-model="selectedPref" class="form-select">
              <option value="" selected>都道府県を選択</option>
              <option v-for="pref in prefList" :value="pref.pref_roma">{{ pref.pref_jp }}</option>
            </select>
          </div>
          <div v-if="selectedPref" class="address__select">
            <select name="municipal" id="municipal" v-model="selectedCitycode" class="form-select">
              <option value="" selected>市区町村を選択</option>
              <option v-for="city in cityListOfSelectedPref" :value="city.citycode">{{ city.name }}</option>
            </select>
          </div>
        </div>
        <button class="button" :disabled="isButtonDisabled">
          <CommonButton :button="button" @click="goToResultPage"></CommonButton>
        </button>
        <div class="content">
          <p class="content__title">写真の撮り方</p>
          <img src="/assets/img/image_method.png" width="325" height="148" alt="">
          <p class="content__text">ピントが合っていて、つぼみの様子が<br>よくわかる写真を撮影または選択してください</p>
        </div>
      </div>
      <ErrorModal v-if="postFailed" @closeModal="handleCloseModal('postFailed')" :imageUploaded="imageUploaded" :selectedCitycode="cityCode" :error="'postFailed'"></ErrorModal>
      <ErrorModal v-if="invalidFileDetected" @closeModal="handleCloseModal('invalidFileDetected')" :error="'invalidFileDetected'"></ErrorModal>
    </div>
    <LoadingAnimation v-if="isLoadingNow"></LoadingAnimation>
  </div>
</template>

<style lang="scss" scoped>
.registration {
  @include wrap();
  @include flex-column();
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 100svh;
  & > * {
    position: relative;
  }
  .title {
    color: $strong;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.35em;
  }
  .box {
    @include flex-column();
    @include box();
    align-items: center;
  }
  .upload {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 130px;
    border-radius: 6px;
    border: 1px solid $border;
    background-color: $white;
    background-image: url("/assets/img/icon_camera.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 72px;
    &__text {
      display: block;
      color: #DF0095;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.5em;
    }
  }
  .image {
    @include flex-column();
    align-items: center;
    gap: 10px;
    &__block {
      height: 320px;
      /* width: 200px;
      aspect-ratio: 16 / 9; */
      background-color: rgb($black, .5);
    }
  }
  .link {
    &__text {
      color: $wni;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
      text-decoration: underline;
    }
  }
  input {
    display: none;
  }
  .address {
    @include flex-column();
    gap: 5px;
    &__heading {
      color: $border;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
    }
    &__title {
      margin-top: 6px;
      padding-left: 20px;
      background-image: url("/assets/img/icon_address.svg");
      background-position: left center;
      background-repeat: no-repeat;
      background-size: contain;
      color: $black;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }
    &__point {
      color: $black;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
    }
    &__text {
      color: $black;
      font-size: 12px;
      line-height: 1.5em;
    }
    &__select {
      position: relative;
      width: 100%;
      border-radius: 5px;
      border: 1px solid #666;
      background-color: $white;
      &::after {
        position: absolute;
        top: 50%;
        right: 5px;
        width: 16px;
        height: 14px;
        margin-top: -6px;
        background-color: $black;
        clip-path: polygon(0 0, 100% 0, 50% 100%);
        content: '';
      }
      select {
        width: 100%;
        padding-left: 10px;
        padding-right: 26px;
        color: $black;
        font-size: 14px;
        font-weight: 600;
        line-height: 30px;
        outline: none;
      }
    }
  }
  .content {
    @include flex-column();
    gap: 15px;
    &__title {
      padding: 8px 10px;
      background-color: $item;
      color: $font;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
    }
    &__text {
      color: $font;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.5em;
    }
  }
  .button {
    width: 150px;
  }
  .footer__link {
    //width: calc(100% + 20px);
    width: 100%;
    padding: 20px;
    background-color: $white;
    color: $strong;
    font-size: 15px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }
}
</style>
